<template>
  <v-card class="elevation-0 mt-0 rounded-0">
    <v-card
    id="title_map_snapshot"
      v-if="loadingfolder"
      class="container_showonmap ma-3 elevation-0 rounded-0 mt-0 pb-3 mt-0"
      style="border: solid 1px #e0e0e0"
    >
      <v-toolbar
        v-if="loadingfolder"
        color="#F7F7F7"
        dense
        class="elevation-0 rounded-0"
      >
        <v-toolbar-title
          >{{ vesselData.name }} | {{ vesselData.pt_name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-btn
          small
          class="elevation-0 rounded-0"
          icon
          @click="closeShow(), (showpict = null), (showpictonclick = null)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

   
      <v-divider></v-divider>
      <v-card
        class="elevation-0 rounded-0 ma-3"
        color="#FFF"
        style="border: solid 1px #e0e0e0"
      >
      <v-toolbar
        v-if="loadingfolder"
        class="elevation-0 rounded-0"
        dense
      >
        <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="border: solid 1px #e0e0e0"
              small
              class="rounded-0 pa-1 elevation-0 ma-0"
              color="#ffff"
              v-bind="attrs"
              v-on="on"
            >
              {{ kFormatter(itemsPerPageImage)
              }}<v-icon small style="margin-left: 0.2em"
                >mdi-unfold-more-horizontal</v-icon
              >
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="itemsPerPageImage = 10"
              ><v-list-item-title>10</v-list-item-title></v-list-item
            >
            <v-list-item @click="itemsPerPageImage = 25"
              ><v-list-item-title>25</v-list-item-title></v-list-item
            >
            <v-list-item @click="itemsPerPageImage = 50"
              ><v-list-item-title>50</v-list-item-title></v-list-item
            >
            <v-list-item @click="itemsPerPageImage = 100"
              ><v-list-item-title>100</v-list-item-title></v-list-item
            >
          </v-list>
        </v-menu>
        <v-spacer style="width:67%"></v-spacer>
          <v-text-field
              style="border: solid 1px #e0e0e0"
              width="40"
              v-model="searchImage"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
              
            ></v-text-field>
      </v-toolbar>
    
      <v-divider></v-divider>
      <v-toolbar  v-if="loadingfolder && filterList != null" height="fit-content" class="elevation-0 rounded-0">
        <div style="max-width:90em">
          <v-btn
          class="elevation-0 rounded-0"
          @click="
            (showpictonclick = true),
              onFilterClick(filter.channel),
              (filter_btn_clicked = filter.id)
          "
          
          style="margin-right: 0.9em;border: solid 1px #e0e0e0"
          :color="filter_btn_clicked == filter.id ? '#1976D2' : '#F7F7F7'"
          :dark="filter_btn_clicked == filter.id ? true : false"
          :key="filter.id"
          v-for="filter in filterList"
          small
        >
          {{ filter.label }}
        </v-btn>
        </div>
      </v-toolbar>
      <v-divider></v-divider>
        <v-container
          style="margin-top: 0"
          v-if="!snapshotpict"
          fill-height
          fluid
        >
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>
    
        <v-data-table
          v-if="snapshotpict"
          :search="searchImage"
          :items="snapshotpict"
          class="elevation-0 image"
          :items-per-page="itemsPerPageImage"
          :headers="headersImage"
          hide-default-footer
          hide-default-header
          :page.sync="pageImage"
          @page-count="pageCountImage = $event"
        >
          <template v-slot:item="row">
            <tr style="border-bottom: none; margin-left: 3em">
              <td
                style="
                  padding: 0.9em;
                  background-color: #ffff;
                  border-bottom: none;
                "
              >
                <v-card
                  style="border: solid 1px #e0e0e0"
                  class="elevation-0 rounded-0"
                  @click="(imageOpen = true), (imageData = row.item)"
                >
                  <img
                    class="imgsnapshot"
                    v-bind:src="row.item.src"
                    style="cursor: pointer"
                  /><br />
                  <div
                    class="ma-0 ml-2"
                    v-if="filterList.length == 0"
                    style="text-align: left"
                  >
                    {{ row.item.label }}
                  </div>

                  <div
                    class="ma-0 ml-2"
                    v-if="filterList.length != 0"
                    style="text-align: center; display: block; text-align: left;max-width:10em"
                  >
                    <p>{{ row.item.label }}</p>
                    <p style="margin-top: -1em" class="wrap-it">{{ row.item.chLabel }}</p>
                  </div>
                </v-card>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-toolbar
         
          dense
          class="elevation-0 rounded-0"
          color="#f7f7f7"
        >
          <p  v-if="snapshotpict" class="mt-3" style="font-size: 0.8em">
            Showing 1 to {{ itemsPerPageImage }} of
            {{ snapshotpict.length }} entries
          </p>
          <v-spacer></v-spacer>
          <v-pagination
          v-if="snapshotpict"
            color="primary"
            v-model="pageImage"
            :length="pageCountImage"
            :total-visible="7"
          ></v-pagination>
        </v-toolbar>
      </v-card>
      <v-card
        class="elevation-0 rounded-0 ma-3 mt-0 mb-0"
        style="border: solid 1px #e0e0e0"
      >
        <v-toolbar
          v-if="loadingfolder"
          color="#fff"
          class="elevation-0 rounded-0"
          dense
        >
          <v-toolbar-title>
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="border: solid 1px #e0e0e0"
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPageFolders)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="itemsPerPageFolders = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageFolders = 25"
                  ><v-list-item-title>25</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageFolders = 50"
                  ><v-list-item-title>50</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageFolders = 100"
                  ><v-list-item-title>100</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu></v-toolbar-title
          >
          <v-spacer style="width:67%"></v-spacer>
          <v-text-field
              style="border: solid 1px #e0e0e0"
              width="40"
              v-model="searchFolder"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
              
            ></v-text-field>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card v-if="loadingfolder" class="elevation-0 rounded-0">
          <!-- <v-data-table
            v-if="!snapshotfolder"
            :items="skeleton_data"
            style="border-bottom: none"
            class="elevation-1 image"
            :items-per-page="itemsPerPageFolders"
            hide-default-footer
            :page.sync="pageFolders"
            @page-count="pageCountFolders = $event"
          >
            <template v-slot:item="row">
              <tr style="margin-left: 3em">
                
                <td
                  style="
                    padding: 0.5em;
                    background-color: #fff;
                    border-bottom: none;
                  "
                >
                  <v-img
                    style="padding: 2em"
                    width="7em"
                    :src="folderloading"
                  ></v-img>

                  {{ row.item.data }}
                </td>
              </tr>
            </template>
          </v-data-table> -->
       
          <v-data-table
            v-if="snapshotfolder"
            :search="searchFolder"
            :items="dirLabel_"
            class="elevation-0 image"
            :items-per-page="itemsPerPageFolders"
            :headers="headersFolder"
            hide-default-footer
            hide-default-header
            :page.sync="pageFolders"
            @page-count="pageCountFolders = $event"
          >
            <template v-slot:item="row">
              <tr style="border-bottom: none;margin-left: 3em">
                <td
                style="
                  padding: 0.9em;
                  background-color: #ffff;
                  border-bottom: none;
                "
              >
                <v-card
                 :color="folderSelect== row.item.label_search ? '#F7F7F7' :'#fff'"
                  style="border: solid 1px #e0e0e0;text-align:center"
                  class="elevation-0 rounded-0 pa-2"
                  @click="
                      onFolderClick(vesselData.id, row.item.label_search),
                        (showpictonclick = true)
                    "
                >
                  <!-- <img
                    class="imgsnapshot"
                    v-bind:src="row.item.src"
                    style="cursor: pointer"
                  /><br /> -->
                  <v-icon x-large>{{folderSelect== row.item.label_search?'mdi-folder' : 'mdi-folder-outline'}}</v-icon>
                  <br />
                  <div
                    class="ma-0 ml-2"
                   
                    style="text-align: left"
                  >
                  {{ row.item.label_search }}
                  </div>

                
                </v-card>
              </td>
              
              </tr>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-toolbar
            v-if="snapshotfolder"
            dense
            class="elevation-0 rounded-0"
            color="#f7f7f7"
          >
            <p class="mt-3" style="font-size: 0.8em">
              Showing 1 to {{ itemsPerPageFolders }} of
              {{ snapshotfolder.dir_label.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              color="primary"
              v-model="pageFolders"
              :length="pageCountFolders"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>
      </v-card>
    </v-card>

    <!--Modal Image-->
    <v-dialog class="rounded-0 elevation-0" v-model="imageOpen" width="800px">
      <v-card class="rounded-0 elevation-0" v-if="imageData">
        <v-toolbar dense color="#fff" class="elevation-0 rounded-0 mb-3">
          <v-toolbar-title
            >{{ imageData.label }} | {{ vesselData.name }} |
            {{ vesselData.pt_name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2 rounded-0 elevation-0"
            fab
            small
            color="#fff"
            @click="imageOpen = null"
          >
            <v-icon dark> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
       
         <v-card-text >
          <img
          style="width:100%"
          :src="imageData.src"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        />
        
        <v-chip
          color="#F7F7F7"
          class="elevation-0 rounded-0"
          style="margin-top: 20px;"
        >
          <v-card-subtitle>
            {{ imageData.filename }}
          </v-card-subtitle>
        </v-chip>
         </v-card-text>
     
      </v-card>
    </v-dialog>
    <!--Modal Image End-->
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      searchImage:"",
      imageOpen: null,
      imageData: null,
      searchFolder:"",
      itemsPerPage: 10,
      showpictonclick: null,
      page: 1,
      pageCount: 0,
      itemsPerPageImage: 25,
      pageImage: 1,
      pageCountImage: 0,
      itemsPerPageFolders: 25,
      pageFolders: 1,
      pageCountFolders: 0,
      pageSize: 1,
      loadernavplus: require("@/assets/img/load100new.gif"),
      folderclose: require("@/assets/img/close-folder.png"),
      folderloading: require("@/assets/img/loading-folder.png"),
      foldercloseagain: require("@/assets/img/close-folder.png"),
      folderopen: require("@/assets/img/open-folder.png"),
      headersFolder: [
        { text: "", value: "label_search", sortable: false },  
      ],
      headersImage: [
        { text: "", value: "label", sortable: false },
        { text: "", value: "chLabel", sortable: false },  
      ],
    };
  },
  methods: {
    ...mapActions([
      "closeShow",
      "fetchSnapshot",
      "snapshotFolder",
      "FolderClick",
      "vesselDataSet",
      "FilterClick",
      "addsnapshot_executed"
    ]),

    async onFolderClick(id, label) {
      $("html, body").animate(
        {
          scrollTop: $("#title_map_snapshot").offset().top - 109,
        },
        800
      );
      this.folderOnSelect = null;
      const dataimg = {
        id: id,
        label: label,
        token: localStorage.getItem("token"),
      };
      console.log(label);
      console.log(this.vesselData.id);
      this.FolderClick(dataimg);
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    async onFilterClick(ch) {
      const dataimg = {
        id: this.vesselData.id,
        label: this.folderSelect,
        ch: ch,
        token: localStorage.getItem("token"),
      };

      console.log(dataimg);
      this.FilterClick(dataimg);
    },
  },

  mounted(){
    var mama = this
    if (!mama.snapshot_executed) {
      //console.log("jalan title map");
      mama.addsnapshot_executed(true);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_snapshot").offset().top - 109,
        },
        800
      );
    } else {
      ////console.log("Muncul"), //console.log(mama.sailink_executed);
    }
  },

  computed: {
    ...mapGetters([
      "folderSelect",
      "filterList",
      "snapshotData",
      "snapshotpict",
      "snapshotfolder",
      "loadingimage",
      "loadingfolder",
      "vesselData",
      "snapshot_executed",
      "dirLabel_"
    ]),
  },
};
</script>

<style lang="scss" scoped>
.wrap-it{
word-wrap: break-word;
}

.margintab {
  margin-top: -25px;
}

.bxfile {
  font-size: 40px;
}

.imgsnapshot {
  width: 150px;
  margin: 10px;
}

.datasnapshot {
  top: 70px;
}


.image th{
    background-color: #0479f5;
    color: #fff;
  }



.image{
  background-color:#FFFF;
}


.image tbody {
    display: flex;
    white-space: initial;
    flex-wrap: wrap;
    text-align: center;
    width: 104vw;
    padding: 1em 1em 0.5em 0.5em;
}
</style>
